import logo from './logo.png'
import heroHome from './hero-home.png'
import celularHome from './celular-hero.webp'
import cel from './cel.png'
import imgLogin from './hero-login.png'

export default{
    "celularHome":celularHome,
    "logo":logo,
    "heroHome":heroHome,
    "cel":cel,
    "imgLogin":imgLogin,
}